<template>
  <div>
    <finances-report/>
  </div>
</template>

<script>
// Vuex
import { mapActions } from "vuex";

import FinancesReport from "../../../components/filtros/lineas/FinancesReport.vue";

export default {
  components: {
    FinancesReport,
  },
  methods: {
    // Acciones de Vuex
    ...mapActions(["AccionCambiar"]),
        ...mapActions("lineas", [
      "actionSetDataListaNaviera",
      "actionSetDataListaCliente",
      "actionSetDataListaPOD",
      "actionSetDataListaNave"
    ]),

    // Función para actualizar url en state
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },
  },
  created() {
    // Ejecución de actualizarURL una vez que se carga el componente
    this.actualizarURL();
  },
};
</script>
<style></style>
